class ColetoresModal {
    constructor($scope, gql) {
        this.gql = gql
        this.coletores = []
        this.$apply = $scope.$apply.bind($scope)
        this.removePromises = {}
        this.empresas = []

        this.coletorFields = `
            id
            nome
            ultimoEnvio
            status
            versao
            configs {
                id
                diretorio
                operacao
                documento
                ultimoArquivo
                status
                empresa {
                    id
                    razaoSocial
                    raizCnpj
                }
            }
        `
    }

    $onInit() {
        this.listPromise = Promise.all([
            this.getColetores(),
            this.getEmpresas()
        ])

        this.inWindows = !navigator.platform.startsWith("Linux")
    }

    $onDestroy() {
        this.unsubscribers.forEach(unsubscriber => unsubscriber())
    }

    subscribeCreated(usuarioId) {
        const query = `
            subscription($usuarioId: Int!) {
                coletorCreated(usuarioId: $usuarioId) {
                    ${this.coletorFields}
                }
            }
        `

        return this.gql.subscribe(query, { usuarioId }, data => {
            this.$apply(() => this.onEvent(data))
        })
    }

    subscribeUpdated(usuarioId) {
        const query = `
            subscription($usuarioId: Int!) {
                coletorUpdated(usuarioId: $usuarioId) {
                    ${this.coletorFields}
                }
            }
        `

        return this.gql.subscribe(query, { usuarioId }, data => {
            this.$apply(() => this.onEvent(data))
        })
    }

    subscribeDeleted(usuarioId) {
        const query = `
            subscription($usuarioId: Int!) {
                coletorDeleted(usuarioId: $usuarioId) {
                    id
                }
            }
        `

        return this.gql.subscribe(query, { usuarioId }, data => {
            this.$apply(() => this.onEvent(data))
        })
    }

    onEvent({ data: { coletorUpdated, coletorCreated, coletorDeleted } }) {
        if (coletorUpdated) {
            this.coletores = this
                .coletores
                .map(coletor => {
                    if (coletor.id == coletorUpdated.id) {
                        return { ...coletor, ...coletorUpdated }
                    }

                    return coletor
                })
        }

        if (coletorCreated) {
            this.coletores.push(coletorCreated)
        }

        if (coletorDeleted) {
            this.coletores = this
                .coletores
                .filter(coletor => coletor.id != coletorDeleted.id)
        }
    }

    downloadMsi() {
        this.downloadPackage(".msi")
    }

    downloadDeb() {
        this.downloadPackage(".deb")
    }

    downloadTar() {
        this.downloadPackage(".tar.gz")
    }

    downloadPackage(extension) {
        open(`https://eficiencia-fiscal.sfo2.digitaloceanspaces.com/coletor_xml/ColetorXML_Setup${extension}`, '_blank')
    }

    removeColetor(coletor) {
        const query = gql`
            mutation DeleteColetor($coletorId: String!) {
                deleteColetor(id: $coletorId) {
                    id
                }
            }
        `
        const mensagem = `
        Este coletor será removido automaticamente de seu computador e do Eficiência Fiscal. 
        <br/>
        Caso deseje utilizá-lo novamente, será necessário configurar novamente.
        `

        Confirm
            .warning('Deseja realmente desinstalar este coletor?', mensagem, {
                'Não': angular.noop,
                'Sim': () => {
                    this.$apply(() => {
                        coletor.removePromise = this
                            .gql
                            .mutate(query, { coletorId: coletor.id })
                            .then(() => {
                                this.coletores = this
                                    .coletores
                                    .filter(col => col.id !== coletor.id)
                            })
                            .then(() => this.$apply())
                            .catch(console.error)
                    })
                }
            })
    }

    getColetores() {
        const query = gql`
            query ListColetores {
                usuarioAtual {
                    id
                    coletores {
                        ${this.coletorFields}
                    }
                }
            }        
        `

        return this
            .gql
            .query(query)
            .then(({ usuarioAtual }) => usuarioAtual)
            .then(usuarioAtual => {
                this.coletores = usuarioAtual.coletores

                const usuarioId = parseInt(usuarioAtual.id)

                this.unsubscribers = [
                    this.subscribeCreated(usuarioId),
                    this.subscribeUpdated(usuarioId),
                    this.subscribeDeleted(usuarioId)
                ]
            })
    }

    getEmpresas() {
        const query = gql`
            query ListPermissoes {
                usuarioAtual {
                    id
                    permissoes {
                        admin
                        empresa {
                            id
                            razaoSocial
                            raizCnpj
                        }
                        filiais {
                            id
                            ferramentasContratadas
                        }
                    }
                }
            }
        `

        return this.gql.query(query)
            .then(({ usuarioAtual: { permissoes } }) => permissoes)
            .then(permissoes =>
                permissoes
                    .filter(permissao => permissao.admin && permissao.empresa)
                    .filter(permissao =>
                        permissao.filiais
                            .flatMap(filial => filial.ferramentasContratadas)
                            .includes("arquivos-digitais-coletor-xml")
                    )
                    .map(permissao => permissao.empresa)
                    .map(empresa => ({ ...empresa, id: parseInt(empresa.id) }))
            )
            .then(empresas => this.empresas = empresas)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('coletoresModal', {
        controller: ['$scope', 'gql', ColetoresModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <modal modal-title="Coletores" close="$ctrl.close">
                <modal-body>
                    <loading promise="$ctrl.listPromise" on-retry="$ctrl.$onInit()">
                        <highlighted>
                            <main ng-if="!$ctrl.coletores.length">Este usuario não possui nenhum coletor instalado.</main>
                            <main ng-if="$ctrl.coletores.length">Abaixo estão seus coletores.</main>
                            <secondary>
                                Você pode instalar um novo coletor utilizando as opções abaixo
                            </secondary>
                        </highlighted>

                        <div class="text-center" style="margin-bottom: 20px">
                            <i class="fa fa-windows"></i> 
                            <a href="javascript:void(0)" ng-click="$ctrl.downloadMsi()">
                                Windows <small class="text-muted">(.msi)</small>
                            </a>
                            <span class="text-muted" style="margin: 0 13px;">|</span>
                            <i class="fa fa-linux"></i>
                            <a href="javascript:void(0)" ng-click="$ctrl.downloadDeb()">
                                Debian <small class="text-muted">(.deb)</small>
                            </a>
                            <span class="text-muted" style="margin: 0 3px;">•</span>
                            <a href="javascript:void(0)" ng-click="$ctrl.downloadTar()">
                                Outras distros <small class="text-muted">(.tar.gz)</small>
                            </a>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 coletor-details slide-left" ng-repeat="coletor in $ctrl.coletores">
                                <promise-tracker promise="coletor.removePromise" active="coletor.removeActive">
                                    <coletor-details 
                                        ng-if="!coletor.editing" 
                                        loading="coletor.removeActive" 
                                        on-remove="$ctrl.removeColetor(coletor)" 
                                        empresas="$ctrl.empresas"
                                        coletor="coletor">
                                    </coletor-details>
                                </promise-tracker>
                            </div>
                        </div>
                    </loading>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        `
    })
